import type { Element } from './ChipSelector';

export function sortElementsByName<T>(elements: Array<Element<T>>): Array<Element<T>> {
    return [...elements].sort((left, right) =>
        left.name.toLocaleLowerCase().localeCompare(right.name.toLocaleLowerCase())
    );
}
